export default "__VITE_ASSET__nxSmof0n__"